module.exports = __webpack_public_path__ + "img/operator_not_reachable.82c8d39b.svg";